export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('app:mounted', () => {
    const mainStore = useLocalStorage()
    const signinStore = useSigninBaseStore()
    const loginSdkStore = useLoginSdkStore()

    const savedState = localStorage.getItem('mainStore')
    const signinState = sessionStorage.getItem('signinStore')
    const loginSdkState = sessionStorage.getItem('loginSdkStore')

    if (savedState) {
      mainStore.$patch(JSON.parse(savedState))
    }

    if (signinState) {
      signinStore.$patch(JSON.parse(signinState))
    }

    if (loginSdkState) {
      loginSdkStore.$patch(JSON.parse(loginSdkState))
    }

    // 상태가 변경될 때마다 로컬 스토리지에 저장
    mainStore.$subscribe((_: any, state: any) => {
      localStorage.setItem('mainStore', JSON.stringify(state))
    })

    signinStore.$subscribe((_: any, state: any) => {
      sessionStorage.setItem('signinStore', JSON.stringify(state))
    })

    loginSdkStore.$subscribe((_: any, state: any) => {
      sessionStorage.setItem('loginSdkStore', JSON.stringify(state))
    })
  })
})
